export default "__VITE_ASSET__KJ0pv0$f__"